/* ============================================================================
   Scroll fade-ins, without GSAP.

   CHANGED: this file used to drive [fade-in-anim] through gsap + ScrollTrigger.
   PageSpeed measured ScrollTrigger.min.js at 2,984ms of CPU on the homepage, more
   than GTM, Facebook, Clarity and GoKwik combined, and it also showed up under
   Forced reflow and in the 2,777ms of Style and Layout. 147 of the 171 templates
   contained no section that used GSAP at all.

   Both libraries are now gone from the head. The fades are done with an
   IntersectionObserver, which does its work off the main thread and costs
   effectively nothing. The initial hidden state and the transition live in an
   inline <style> in layout/theme.liquid so there is no flash before this runs,
   with a <noscript> block that reveals everything if scripting is off.

   Visual result matches the old animation: fade in with a slide up, half a
   second, triggered when the element is near the viewport, and it only plays
   once.
   ============================================================================ */

(function () {
  var els = document.querySelectorAll('[fade-in-anim]');
  if (!els.length) return;

  function revealAll() {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  /* Older browsers with no IntersectionObserver just get the content, unanimated. */
  if (!('IntersectionObserver' in window)) { revealAll(); return; }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      entries[i].target.classList.add('is-in');
      io.unobserve(entries[i].target);   /* fire once, then stop watching */
    }
  }, {
    /* Matches the old ScrollTrigger start of "top 95%": begin as the element
       reaches the last 5% of the viewport. */
    rootMargin: '0px 0px -5% 0px',
    threshold: 0
  });

  for (var i = 0; i < els.length; i++) io.observe(els[i]);

  /* Safety net: if anything goes wrong, never leave content invisible. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) els[i].classList.add('is-in');
      }
    }, 1200);
  });
})();

/* ============================================================================
   GSAP no-op shim.

   Seven sections still contain their own GSAP animation code: Philosophy_section,
   Scicollagen, Scientific_Result, Science_common, Text_animated, Text_banner and
   Trace_Swiper. Their script blocks also contain Swiper setup, tab switching and
   other logic that must keep working, and a ReferenceError on `gsap` would abort
   the rest of the block.

   Every one of those sections defers its GSAP code to DOMContentLoaded or
   jQuery ready, and this file is deferred, so this shim is always in place first.
   The animations become no-ops and the surrounding logic is untouched. Nothing
   ends up hidden, because those sections only ever set opacity through gsap.set,
   which now does nothing.

   This is deliberate rather than editing seven files whose script blocks carry
   cart-adjacent and slider logic. If those animations are wanted back, remove this
   shim and restore the two library tags in layout/theme.liquid.
   ============================================================================ */
(function () {
  if (typeof window.gsap !== 'undefined') return;

  function chain() { return api; }
  var tl = {
    to: chain, from: chain, fromTo: chain, set: chain, add: chain,
    call: chain, addLabel: chain, play: chain, pause: chain, kill: chain
  };
  function timeline() { return tl; }
  for (var k in tl) tl[k] = function () { return tl; };

  var api = {
    to: timeline, from: timeline, fromTo: timeline, set: timeline,
    timeline: timeline, registerPlugin: function () {}, config: function () {},
    defaults: function () {}, killTweensOf: function () {},
    ticker: { lagSmoothing: function () {}, add: function () {}, remove: function () {} },
    utils: {
      toArray: function (t) {
        if (typeof t === 'string') return Array.prototype.slice.call(document.querySelectorAll(t));
        if (!t) return [];
        return t.length !== undefined ? Array.prototype.slice.call(t) : [t];
      }
    }
  };

  api.__isNoopShim = true;
  window.gsap = api;
  window.ScrollTrigger = {
    create: function () { return { kill: function () {} }; },
    batch: function () {}, refresh: function () {}, config: function () {},
    matchMedia: function () { return { add: function () {} }; },
    getAll: function () { return []; }, killAll: function () {}
  };
  window.ScrollToPlugin = {};
})();

// ===== Megamenu hover logic =====
// CHANGED: ported from jQuery to plain JS, same behaviour: open the desktop mega menu
// when the pointer enters "Shop all" or the menu, close it one second after the pointer
// has left both. animation.js is a module script, so it runs after the DOM is parsed.
(function () {
  var trigger = document.querySelector('li#Shop-all');
  var menu = document.querySelector('.megamenu-outline');
  if (!trigger || !menu) return;
  var hideTimeout;

  function showMenu() {
    clearTimeout(hideTimeout);
    menu.classList.add('active');
  }

  function hideMenu() {
    hideTimeout = setTimeout(function () {
      if (!trigger.matches(':hover') && !menu.matches(':hover')) {
        menu.classList.remove('active');
      }
    }, 1000); // wait 1s after leaving both areas
  }

  trigger.addEventListener('mouseenter', showMenu);
  trigger.addEventListener('mouseleave', hideMenu);
  menu.addEventListener('mouseenter', showMenu);
  menu.addEventListener('mouseleave', hideMenu);
})();
